const AUTO_SLUGS = ["new-co-group", "new-co-local", "parkmobile"];

export function deleteAutoSlug(url: string) {
  let correctUrl = url;

  for (const autoSlug of AUTO_SLUGS) {
    correctUrl = correctUrl.replace(autoSlug, "");
  }

  // Clean up any double slashes and normalize
  correctUrl = correctUrl.replace(/\/+/g, "/");

  // Remove leading/trailing slash (at most one of each after the collapse above)
  if (correctUrl.startsWith("/")) correctUrl = correctUrl.slice(1);
  if (correctUrl.endsWith("/")) correctUrl = correctUrl.slice(0, -1);

  return correctUrl;
}

export function deleteAutoSlugNavigation(url: string) {
  let correctUrl = url;

  const segments = correctUrl.split("/").filter(Boolean);
  const filteredSegments = segments.filter(
    (segment) => !AUTO_SLUGS.includes(segment),
  );

  correctUrl =
    filteredSegments.length > 0 ? "/" + filteredSegments.join("/") : "/";

  return correctUrl;
}
